export function load_activities(){
    (function($) {
        function loadActivities(category, page = 1 ) {
            $.ajax({
                url: ajax_object.ajax_url,  // URL AJAX di WordPress
                type: 'POST',
                data: {
                    action: 'load_activities_ajax', // Nome della funzione PHP che gestisce la richiesta
                    cat: category,
                    paged: page // Passiamo il numero della pagina
                },
                success: function(response) {
                    $("#activities_container_wrapper").html(response.html); // Aggiorna il contenuto
                    
                    // Gestione della paginazione
                    $("#prev_page").off("click").on("click", function() {
                        if (response.current_page > 1) {
                            loadActivities(category, response.current_page - 1);
                        }
                    });

                    $("#next_page").off("click").on("click", function() {
                        if (response.current_page < response.max_pages) {
                            loadActivities(category, response.current_page + 1);
                        }
                    });
                },
                error: function(error) {
                    console.log("Errore AJAX:", error);
                }
            });
        }

        // 1️⃣ Carica le attività all'avvio con il primo input selezionato
        let defaultCategory = $("input[name='activities_filter']:checked").val();
        loadActivities(defaultCategory);

        // 2️⃣ Cambia categoria al cambio di selezione
        $("input[name='activities_filter']").on("change", function() {
            let selectedCategory = $(this).val();
            loadActivities(selectedCategory, 1);
        });
    })(jQuery);
}